module.exports = __webpack_public_path__ + "img/user-3.981bb788.jpg";